import { useEffect } from "react";
import Combobox from "react-widgets/Combobox";

import "react-widgets/styles.css";

const AppointmentSearchPanel = ({
  onSearch,
  barberList,
  selectedBarber,
  reference,
  selectCustomer,
  statusList,
  customerList,
  selectedStatus,
  setSelectedStatus,
  setSelectCustomer,
  setSelectedBarber,
  setReference,
  setDate,
  date,
}) => {
  return (
    <div className="col-12">
      <div className="card  p-3 mb-3">
        <div className="row g-3">
          <div className="col-4 form-control-container ">
            <label htmlFor="Date" className="form-label form-control-label">
              Date
            </label>
            <input
              type="date"
              className="form-control form-input"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </div>
          <div className="col-4 form-control-container ">
            <label htmlFor="Barber" className="form-label form-control-label">
              Barber
            </label>
            <Combobox
              onSelect={(value) => setSelectedBarber(value)}
              data={barberList}
              dataKey="id"
              textField="name"
              value={selectedBarber}
              defaultValue={barberList[0]}
              containerClassName={" form-combobox"}
              autoComplete="off"
            />
          </div>
          <div className="col-4 form-control-container ">
            <label htmlFor="tva" className="form-label form-control-label">
              Reffernce code
            </label>
            <input
              type="text"
              className="form-control form-input"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
            />
          </div>
          <div className="col-4 form-control-container ">
            <label htmlFor="tva" className="form-label form-control-label">
              Status
            </label>
            <Combobox
              onChange={(value) => setSelectedStatus(value)}
              data={statusList}
              dataKey="id"
              textField="name"
              value={selectedStatus}
              defaultValue={selectedStatus}
              containerClassName={" form-combobox"}
            />
          </div>
          <div className="col-4 form-control-container ">
            <label htmlFor="tva" className="form-label form-control-label">
              Customer
            </label>
            <Combobox
              onChange={(value) => setSelectCustomer(value)}
              data={customerList}
              dataKey="id"
              textField="name"
              value={selectCustomer}
              defaultValue={customerList[0]}
              containerClassName={" form-combobox"}
            />
          </div>

          <div className="col-4   ">
            <div className="d-flex">
              <button
                className="btn btn-primary p-2 flex-grow-1"
                style={{ height: "55px" }}
                onClick={() => {
                  onSearch();
                }}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentSearchPanel;
